import React, { memo } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import RecordItem from './RecordItem';
import { colorBorder, stickyCol } from './Common';

type RecordProps = {
  items: any[];
  headers: number[];
  loading?: boolean;
  onClickRow?: (id: number) => void;
};

const Record: React.FC<RecordProps> = (props) => {

  return (
    <TableContainer
      component={Paper}
      sx={{
        boxShadow: 'none',
        '& *': { color: 'primary.dark', fontSize: '12px' },
        width: '100%',
        maxHeight: 'calc(100vh - 240px)',
        overflowX: 'auto',
        bgcolor: '#FAFAFA'
      }}
    >
      <Table
        stickyHeader
        sx={{
          '& .MuiTableCell-root.MuiTableCell-head': {
            borderBottom: `1px solid ${colorBorder}`,
            borderRight: `1px solid ${colorBorder}`,
            fontWeight: 700,
            fontSize: '12px',
            height: '36px',
            p: '0px 16px',
            overflow: 'auto',
            '&:nth-of-type(1)': stickyCol(0),
            '&:nth-of-type(2)': stickyCol(240),
            '&:nth-of-type(3)': stickyCol(310)
          }
        }}
        aria-label='simple table'>
        <TableHead >
          <TableRow >
            <TableCell align={'left'} sx={{ minWidth: '240px', maxWidth: '240px', bgcolor: 'primary.light' }}>品名</TableCell>
            <TableCell align={'center'} sx={{ minWidth: '70px', bgcolor: 'primary.light' }}>在庫数</TableCell>
            <TableCell align={'left'} sx={{ minWidth: '69px', bgcolor: 'primary.light' }}></TableCell>
            {props.headers.map((item: number) => (
              <TableCell
                key={item}
                align={'center'}
                sx={{ minWidth: '48px', bgcolor: '#E6E9ED' }}
              >
                <Typography
                  component='label'
                  sx={{
                    fontWeight: '700',
                    fontSize: '12px',
                    lineHeight: '14px'
                  }}
                >
                  {item}
                </Typography>
              </TableCell>
            ))}
            <TableCell align={'left'} sx={{ minWidth: '48px', bgcolor: '#E6E9ED' }}></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {props.loading ? (
            <TableRow>
              <TableCell colSpan={5}>
                <Stack spacing={1}>
                  <Skeleton variant='rounded' width={'100%'} height={40} />
                  <Skeleton variant='rounded' width={'100%'} height={40} />
                  <Skeleton variant='rounded' width={'100%'} height={40} />
                </Stack>
              </TableCell>
            </TableRow>
          ) : (
            <>
              <RecordItem
                items={props.items}
                onClickRow={props.onClickRow}
              />
              {props.items.length === 0 && (
                <TableRow>
                  <TableCell
                    colSpan={props.headers.length}
                    sx={{ textAlign: 'center', verticalAlign: 'center' }}
                  >
                    データがありません
                  </TableCell>
                </TableRow>
              )}
            </>
          )}
        </TableBody>
      </Table>
    </TableContainer >
  );
};

export default memo(Record);
